module.exports = __webpack_public_path__ + "media/custom/images/img5-1355c8d2a39dd1c1260e40e235f4a8ab.svg";